import { KalturaMultiResponse } from '@kaltura-ott/ott-client-types/api';
import { ImageTypeListAction, KalturaImageType, RatioListAction } from '@kaltura-ott/ott-client-types/api/types';
import { KalturaRatio } from '@kaltura-ott/ott-client-types/api/types/KalturaRatio';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AssetPresentationRatioEnum } from '../interfaces';

import { kalturaClient } from './kaltura-clent';

export interface ImageType {
  id: number;
  ratio: AssetPresentationRatioEnum;
  systemName: string;
}

export let imageTypes: ImageType[] = [];

export const imageTypesMap = new Map<ImageType['id'], ImageType>();

const normalizeImageType = (imageType: KalturaImageType, ratioByType: AssetPresentationRatioEnum): ImageType => {
  return {
    id: imageType.id,
    ratio: ratioByType,
    systemName: imageType.systemName,
  };
};

export const getRatiosByImageTypes = (): Observable<KalturaMultiResponse> => {
  const client = kalturaClient();
  const actions = [new RatioListAction(), new ImageTypeListAction()];

  return client.multiRequest(actions).pipe(
    map(([ratiosResponse, imageTypesResponse]) => {
      const ratios = ratiosResponse.result.objects as KalturaRatio[];
      const kalturaImageTypes = imageTypesResponse.result.objects as KalturaImageType[];

      imageTypes = kalturaImageTypes
        .map((type) => {
          const ratioByType = ratios.find((ratio) => ratio.id === type.ratioId);
          return ratioByType && normalizeImageType(type, ratioByType.name as AssetPresentationRatioEnum);
        })
        .filter(Boolean) as ImageType[];

      imageTypesMap.clear();
      imageTypes.forEach((imageType) => imageTypesMap.set(imageType.id, imageType));
    }),
    catchError((error) => {
      return of(error);
    }),
  );
};

export const getRatioByType = (type: number): AssetPresentationRatioEnum | undefined => {
  return imageTypesMap.get(type)?.ratio;
};

export const getTypesByRatio = (ratio: AssetPresentationRatioEnum): ImageType[] => {
  return imageTypes.filter((imageType) => imageType.ratio === ratio);
};

export const getTypeByTypeName = (typeName: string): ImageType | undefined => {
  return imageTypes.find((imageType) => imageType.systemName === typeName);
};

export const getSystemNameById = (id: number): string | undefined => {
  return imageTypesMap.get(id)?.systemName;
};
